var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{tag:"component"},[_vm._t("default",null,{"briefs":_vm.briefs,"close":_vm.close})],2)}
var staticRenderFns = []

export { render, staticRenderFns }